<div class="delivery-page">
<div class="delivery-container" *ngIf="!step3">
  <!-- Header -->
  <div class="header">
    <div class="steps">
    <div class="title"><i (click)="goBack()">keyboard_arrow_left</i> Choose Delivery</div>
    <div class="step">Step 2 of 3</div>
    </div>
      <p class="subtitle">Save cost when parts aren’t urgent.</p>
      <div class="line-indicators">
        <span></span>
        <span></span>
        </div>

  </div>


  <!-- Smart Slot Delivery -->
  <div class="card recommended"  
   [class.selected]="isSelected"
  (click)="selectSlot(1)"
  >
    <div class="recommended-badge">✨ Recommended</div>
      <div class="checkmark" *ngIf="isSelected">✔</div>
    <div class="card-content">
      <div class="card-header">
        <div class="icon delivery-icon"><img src="../../../../assets/images/slot-delivery/car.png"></div>
        <div>
          <h3>{{slotData?.currentSlot.title}} — <span *ngIf="slotData?.currentSlot.shippingCharges ==0">FREE</span>
          <span *ngIf="slotData?.currentSlot.shippingCharges >0">₹{{slotData?.currentSlot.shippingCharges}}</span></h3>
          <p class="time"><img src="../../../../assets/images/slot-delivery/time.png"> Dispatches {{ getDeliveryLabel(slotData?.currentSlot.shipmentCutoffTime) }}</p>
          <p class="sub-text">Order By: {{ getUpcoming(slotData?.currentSlot.orderWindowEnd) }}</p>
      <div class="card-footer">
        <span class="tag free">💰 ₹{{slotData?.currentSlot.shippingCharges | number:'1.0-0'}} shipping</span>
        <span class="tag timer">⏰ Order in {{countdown }} </span>
      </div>
      
      <div class="link" (click)="upcomingSlots()">
        <img src="../../../../assets/images/slot-delivery/calender.png">View upcoming slots 
        <i>keyboard_arrow_down</i></div>
        </div>
      </div>
    </div>
  </div>

  <div class="slots-card" *ngIf="upcoming">
  <div class="headers">
    <i class="calendar-icon"><img src="../../../../assets/images/slot-delivery/upcoming.png"></i>
    <span>Upcoming Slots</span>
  </div>

  <div class="slot" *ngFor="let slots of slotData?.upcomingSlots">
    <span class="order">Order By: {{ getUpcoming(slots.orderWindowEnd) }}</span>
    <span class="arrival">Dispatches {{ getDeliveryLabel(slots.shipmentCutoffTime) }}</span>
  </div>

  <!-- <div class="slot">
    <span class="order">Order By: {{ getUpcoming(slotData?.upcomingSlots[1].orderWindowStart) }}</span>
    <span class="arrival">Arrives  {{ getDeliveryLabel(slotData?.upcomingSlots[1].customerDeliveryTime) }}</span>
  </div> -->
</div>


  <!-- Pick up from Store -->
  <div class="card"    
  [class.selected]="isPickUp"
  (click)="selectSlot(2)"
  *ngIf="slotData?.wareHouseData.length>0">
   <div class="checkmark" *ngIf="isPickUp">✔</div>
    <div class="card-content">
      <div class="card-header">
        <div class="icon store-icon"><img src="../../../../assets/images/slot-delivery/location.png"></div>
        <div>
          <h3>{{slotData?.wareHouseData[0].title}} — 
            <span class="free" *ngIf="slotData?.wareHouseData[0].shippingCharges ==0">FREE</span>
             <span class="free" *ngIf="slotData?.wareHouseData[0].shippingCharges >0">{{slotData?.wareHouseData[0].shippingCharges}}</span></h3>
          <p class="sub-text">{{slotData?.wareHouseData[0].warehouseName}} - {{slotData?.wareHouseData[0].storeTime}}</p>
          
      <div class="card-footer">
        <span class="tag free" *ngIf="slotData?.wareHouseData[0].shippingCharges ==0">🚫 No shipping fee</span>
        <span class="tag priority">⚡ Priority counter</span>
      </div>
      <div class="link" (click)="goToNext()"><img src="../../../../assets/images/slot-delivery/location-color.png">View on Maps</div>
        </div>
      </div>
      
    </div>
  </div>

  <!-- Instant Delivery -->
  <div class="card" 
  [class.selected]="isInstant"
  (click)="selectSlot(3)" >
  <div class="checkmark" *ngIf="isInstant">✔</div>
    <div class="card-content">
      <div class="card-header">
        <div class="icon instant-icon"><img src="../../../../assets/images/slot-delivery/instant.png"></div>
        <div>
          <h3 *ngIf="shippingCharges > 0">{{slotData?.instantDelivery.title}}— ₹{{shippingCharges  | number:'1.2-2'}}</h3>
          <h3 *ngIf="shippingCharges == 0">{{slotData?.instantDelivery.title}}— Free</h3>
          <div class="extra-cost">
            <div>
            <p  class="sub-text">Dispatches ~15 MINS*</p>
            <p class="sub-text">*Subject to availability</p>
            </div>
            
      <div class="card-footer">
        <span class="tag extra" *ngIf="shippingCharges > 0">💸 Extra cost</span>
      </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="features">
  <div class="feature-item">
    <div class="icons bg-blue">
      <img src="../../../../assets/images/slot-delivery/genuine.png" alt="Genuine Parts">
    </div>
    <p>Genuine Parts</p>
  </div>

  <div class="feature-item">
    <div class="icons bg-green">
      <img  src="../../../../assets/images/slot-delivery/on-time.png" alt="On-time">
    </div>
    <p>On-time</p>
  </div>

  <div class="feature-item">
    <div class="icons bg-yellow">
      <img  src="../../../../assets/images/slot-delivery/track.png" alt="Live Tracking">
    </div>
    <p>Live Tracking</p>
  </div>
</div>

</div>
<div class="delivery-container" *ngIf="step3">
  <!-- Header -->
  <div class="header">
    <div class="steps">
    <div class="title" (click)="backToPrevious()"><i>keyboard_arrow_left</i> Pick up from Store — FREE</div>
    <div class="step">Step 3 of 3</div>
    </div>
      <p class="subtitle">Ready for collection at your convenience.</p>
      <div class="line-indicators">
        <span></span>
        <span></span>
        <span></span>
      </div>

  </div>

<div class="card-map">
  <div class="card-header" (click)="openMap()" style="cursor: pointer;">
    <img [src]="mapImageUrl"  alt="MapView Logo" class="logo" />
  </div>

  <div class="card-body">
    <h3>{{slotData?.wareHouseData[0].warehouseName}}</h3>
    <p>{{slotData?.wareHouseData[0].address1}} {{slotData?.wareHouseData[0].address2}} {{slotData?.wareHouseData[0].country}} {{slotData?.wareHouseData[0].zip}}
    </p>

    <div class="store-hours">
      <span class="icon">🕒</span> Store Hours:  {{slotData?.wareHouseData[0].storeTime}}
    </div>

    <div class="badges">
      <span class="badge no-fee" *ngIf="slotData?.wareHouseData[0].shippingCharges ==0">🚫 No shipping fee</span>
      <span class="badge priority">⚡ Priority counter</span>
    </div>

    <div (click)="openMap()" class="directions-link">
      <img src="../../../../assets/images/slot-delivery/direction.png"> Get Directions
  </div>
  </div>


</div>

<div class="what-to-bring-card">
  <h3 class="card-title">What to bring</h3>
  <ul class="checklist">
    <li class="checklist-item">
      <span class="check-icon">✔</span>
      <div class="item-text">
        <div class="item-title">Valid photo ID</div>
        <div class="item-description">Driver's license, passport, or government ID</div>
      </div>
    </li>
    <li class="checklist-item">
      <span class="check-icon">✔</span>
      <div class="item-text">
        <div class="item-title">Order confirmation</div>
        <div class="item-description">Email or SMS confirmation with order number</div>
      </div>
    </li>
    <li class="checklist-item">
      <span class="check-icon">✔</span>
      <div class="item-text">
        <div class="item-title">Payment method (if applicable)</div>
        <div class="item-description">For any remaining balance or additional items</div>
      </div>
    </li>
  </ul>
</div>

  <div class="features">
  <div class="feature-item">
    <div class="icons bg-blue">
      <img src="../../../../assets/images/slot-delivery/genuine.png" alt="Genuine Parts">
    </div>
    <p>Genuine Parts</p>
  </div>

  <div class="feature-item">
    <div class="icons bg-green">
      <img  src="../../../../assets/images/slot-delivery/on-time.png" alt="On-time">
    </div>
    <p>On-time</p>
  </div>

  <div class="feature-item">
    <div class="icons bg-yellow">
      <img  src="../../../../assets/images/slot-delivery/track.png" alt="Live Tracking">
    </div>
    <p>Live Tracking</p>
  </div>
</div>

</div>
<div class="right-page">
<div class="price-card">
  <h3 class="title">Price Details</h3>

  <div class="row">
    <span>Spares Total</span>
    <span class="value">₹{{cartSubTotal | number:'1.2-2'}}</span>
  </div>

  <div class="row discount">
    <span>Spares Discount</span>
    <span class="value">- ₹{{sparesDiscount | number:'1.2-2'}}</span>
  </div>
  <div class="row"  *ngIf="((isInstant || !(isSelected || isPickUp || isInstant)) && shippingCharges > 0) || (isSelected && slotData?.currentSlot.shippingCharges >0) || (isPickUp && slotData?.wareHouseData[0].shippingCharges >0)">
    <span>
      Shipping Charges 
<i  class="info-icon maticon" mat-raised-button [matTooltip]="'Provides free Shipping for orders above ₹ ' + avoidShippingCharges" (click)="openBottomSheet()" *ngIf="!(step3 || isSelected || isPickUp || isInstant)">
         info_outline</i>
             <i  class="info-icon maticon" mat-raised-button (click)="openPickup()" *ngIf="step3 || isSelected || isPickUp || isInstant">
         info_outline</i>
    </span>
    <span class="value" *ngIf="isInstant || !(isSelected || isPickUp || isInstant)">₹{{shippingCharges | number:'1.2-2'}}</span>
     <span class="value" *ngIf="isSelected">₹{{ slotData?.currentSlot.shippingCharges | number:'1.2-2'}}</span>
     <span class="value" *ngIf="isPickUp" >₹{{ slotData?.wareHouseData[0].shippingCharges | number:'1.2-2'}}</span>
  </div>



    <div class="row"  *ngIf="((isInstant || !(isSelected || isPickUp || isInstant)) && shippingCharges == 0 )|| (isSelected && slotData?.currentSlot.shippingCharges ==0) || (isPickUp && slotData?.wareHouseData[0].shippingCharges ==0)">
    <span>
      Shipping Charges 
  <i  class="info-icon maticon" mat-raised-button [matTooltip]="'Provides free Shipping for orders above ₹ ' + avoidShippingCharges" (click)="openBottomSheet()" *ngIf="!(step3 || isSelected || isPickUp || isInstant)">
         info_outline</i>
             <i  class="info-icon maticon" mat-raised-button (click)="openPickup()" *ngIf="step3 || isSelected || isPickUp || isInstant">
         info_outline</i>
    </span>
    <span class="value">
      <span class="freetag">₹{{shippingCharges | number:'1.0-0'}}</span>
      <span style="color: #4caf50;"> Free</span> </span>
  </div>


  <ng-template #bottomSheetTemplate >
  <div class="bottom-sheet-content">
      <i  class="material-icons" (click)="closeBottomSheet()" style="float: left ; cursor: pointer;">cancel</i>
    <h3 style="font-weight: bold;">Shipping Charge</h3>
    <p style="font-size: 13px;">Autoverse provides free Shipping for orders above {{avoidShippingCharges}}</p>
    <button mat-button class="custom-button" (click)="closeBottomSheet()">Okay, Got it</button>
  </div>
</ng-template> 

  <hr />

  <div class="row total">
    <span>Total</span>
    <span *ngIf="isInstant || !(isSelected || isPickUp || isInstant)">₹{{cartGrandTotal+shippingCharges | number:'1.2-2'}}</span>
     <span *ngIf="isSelected">₹{{cartGrandTotal+ slotData?.currentSlot.shippingCharges| number:'1.2-2'}}</span>
     <span *ngIf="isPickUp">₹{{cartGrandTotal+ slotData?.wareHouseData[0].shippingCharges| number:'1.2-2'}}</span>
  </div>
</div>


</div>
</div>
<!-- Popup Modal Overlay -->
<div class="popup-overlay"  *ngIf="urgent">
  <div class="popup-modal">
    
    <!-- Header Section -->
    <div class="popup-header">
      <img src="../../../../assets/images/slot-delivery/car.png" class="popup-icon">
      <button class="popup-close" (click)="goToPayment(slotData?.instantDelivery.slotId)">×</button>
    </div>

    <!-- Title + Subtitle -->
    <h2 class="popup-title"  *ngIf="shippingCharges > 0">Switch & Save ₹{{shippingCharges | number:'1.0-0'}}</h2>
      <h2 class="popup-title"  *ngIf="shippingCharges == 0">Is it urgent?</h2>
    <p class="popup-subtitle">
      Smart Slot is FREE and helps reduce logistics cost.
    </p>

    <!-- Delivery Timing -->
    <div class="popup-row light-blues">
      <span class="popup-row-icon">⏱</span>
      <span>Dispatches {{ getDeliveryLabel(slotData?.currentSlot.shipmentCutoffTime) }}</span>
    </div>

    <!-- Countdown Timer -->
    <div class="popup-row yellows">
      <span class="popup-row-icon">⏱</span>
      <span>Order within <strong>  {{countdown }}</strong></span>
    </div>

    <!-- Info Badge -->
    <div class="popup-info">
      <i class="popup-dot">check_circle</i>
      Most garages choose Smart Slot to save cost.
    </div>

    <!-- Action Buttons -->
    <button class="popup-btn primary" (click)="selectSlot(1)">Choose Smart Slot Delivery</button>
    <button class="popup-btn secondary" (click)="goToPayment(slotData?.instantDelivery.slotId, slotData?.instantDelivery.slotName)">Proceed with Instant Delivery</button>

    <!-- Footer Icons -->
    <div class="popup-footer">
      <span><i>check_circle</i> Genuine Parts</span>
      <span><i>access_time</i> On-time</span>
      <span><i> location_on</i> Live Tracking</span>
    </div>
  </div>
</div>


  <div class="buttom-button" *ngIf="isPickUp || isInstant || isSelected" >
    <div class="text" *ngIf="isSelected" (click)="proceedInstant(slotData?.currentSlot.slotId, slotData?.currentSlot.title)">✔ Get FREE Smart Slot Delivery </div>
    <div class="text" *ngIf="isPickUp || step3" (click)="proceedInstant(slotData?.wareHouseData[0].slotId, slotData?.wareHouseData[0].title, slotData?.wareHouseData[0].warehouseName)">✔ Confirm Pick-up</div>
    <div class="Proceed" *ngIf="isInstant" (click)="proceedInstant(slotData?.instantDelivery.slotId, slotData?.instantDelivery.title)">⚡ Proceed with Instant <span *ngIf="shippingCharges > 0">(₹{{shippingCharges  | number:'1.2-2'}})</span> <span *ngIf="shippingCharges == 0">(FREE)</span> </div>
  </div>

  <div class="overlay" (click)="openPickup()"  [class.visible]="freeShipping" *ngIf="freeShipping" ></div>
  <div class="popup-overlays"  *ngIf="freeShipping && (step3 || isPickUp)">
<div class="popup">

<div class="header">
    <span class="header1">
    <img class="icon" src="../../../../assets/images/slot-delivery/color-location.png" style="width: 13%;">
    <h2>Why is shipping FREE?</h2>
    </span>
    <i (click)="openPickup()">close</i>
</div>

<p class="subtext">Pick up from our store—no shipping fee.</p>

<div class="location-box">
    <div class="location">
    <img class="location-icon" src="../../../../assets/images/slot-delivery/location-color.png">
    <div class="location-details">
        <p class="address" style="margin: 0;">{{slotData?.wareHouseData[0].warehouseName}}</p>
        <div class="address"> {{slotData?.wareHouseData[0].address1}} {{slotData?.wareHouseData[0].address2}} {{slotData?.wareHouseData[0].country}} {{slotData?.wareHouseData[0].zip}}</div>
        <div class="hours">Open {{slotData?.wareHouseData[0].storeTime}}</div>
    </div>
    </div>
</div>

<div class="tags">
    <div class="tag no-fee"  *ngIf="slotData?.wareHouseData[0].shippingCharges ==0">🚫 No shipping fee</div>
    <div class="tag priority">⚡ Priority counter</div>
</div>

<button class="btn" (click)="openMap()">Get Directions</button>

<div class="change-link" (click)="changeDelivery()">Change delivery</div>

<!-- <p class="note">Bring your Order ID at the counter.</p> -->
</div>

</div>

<div class="popup-overlays" *ngIf="freeShipping && isSelected">
<div class="popup-modal">

    <!-- Header -->
    <div class="popup-header">
    <img src="../../../../assets/images/slot-delivery/light-car.png" class="popup-icon">
    
    <h2 class="popup-title" style="color: black;">Why is shipping FREE?</h2>
    <i class="popup-close" (click)="openPickup()">close</i>
    </div>

    <!-- Title & Subtitle -->
    <p class="popup-subtitle" style="color: #6B7280;">
    You chose Smart Slot. We club orders and deliver in a predictable slot.
    </p>

    <!-- Delivery Info -->
    <div class="popup-row light-blues" style="border: 1px solid #BAE6FD;color: #0369A1;">
    <span class="popup-row-icon">⏱</span>
    <span>Dispatches {{ getDeliveryLabel(slotData?.currentSlot.shipmentCutoffTime) }}</span>
    </div>
    <p class="popup-subtext" style="color: #6B7280;">Order By: {{ getUpcoming(slotData?.currentSlot.orderWindowEnd) }}</p>

    <!-- Benefits List -->
    <div class="popup-benefits">
    <p><img src="../../../../assets/images/slot-delivery/doller.png"> Fewer trips, lower logistics cost</p>
    <p><img src="../../../../assets/images/slot-delivery/right.png"> Predictable delivery window</p>
    <p><img src="../../../../assets/images/slot-delivery/doller.png"> ₹{{slotData?.currentSlot.shippingCharges | number:'1.0-0'}} shipping for this order</p>
    </div>

    <p class="popup-note" style="color: #9CA3AF;">
    Change delivery at the previous step if you need Instant.
    </p>

    <!-- Buttons -->
    <div class="popup-actions">
    <button class="popup-btn primary" (click)="openPickup()">Keep Smart Slot</button>
    <button class="popup-btn secondary" (click)="changeDelivery()">Change delivery</button>
    </div>
    
</div>
</div>

<div class="modal" *ngIf="freeShipping && isInstant && shippingCharges>0">
  <h2>🕒 Why am I paying ₹{{shippingCharges}}?</h2>
  <p class="subtext">Instant sends a separate trip to deliver immediately.</p>
  <p class="free-offer">✨ Free instant delivery on orders above ₹{{avoidShippingCharges}}</p>

  <div class="tip-box">
    <p class="tip">💡 Tip: Choose Smart Slot & Save ₹{{shippingCharges}}</p>
    <p class="catch">⏳{{convertMinutesToTimeLabel(slotData?.currentSlot.orderConfirmTime)}} left to catch {{ getUpcoming(slotData?.currentSlot.shipmentCutoffTime) }} delivery</p>
    <button class="primary" (click)="selectSlot(1)">Switch to Smart Slot</button>
  </div>

  <button class="secondary" (click)="openPickup()">Continue with Instant</button>
</div>

<!-- modal -->
<div class="modal" *ngIf="freeShipping && isInstant && shippingCharges==0">
  <h2>🕒 <strong>Instant is free today</strong></h2>
  <p class="subtext" style="color: black;">
    You're not paying a delivery fee on orders above ₹{{avoidShippingCharges}}.
  </p>

  <p class="green-tip" style="text-align: left;">
    💡 Still better: Smart Slot Dispatches {{ getDeliveryLabel(slotData?.currentSlot.shipmentCutoffTime) }} and helps cut extra trips.
  </p>

  <div class="info-box">
    <p class="green-tip">✨ Choose Smart Slot for predictable delivery</p>
    <p class="catch">⏳ {{convertMinutesToTimeLabel(slotData?.currentSlot.orderConfirmTime)}} left to catch {{ getUpcoming(slotData?.currentSlot.shipmentCutoffTime) }} delivery</p>
    <button class="primary" (click)="selectSlot(1)">Choose Smart Slot</button>
  </div>

  <button class="secondary" (click)="openPickup()">
    Proceed with Instant
  </button>
</div>

